import { RootState } from 'lib/core/data/reducer'

export const isFetchingSelector = (state: RootState) => {
  const common = state.common
  return (common.categoryList.isFetching || !common.categoryList.payload) ||
    (common.storeConfig.isFetching || !common.storeConfig.payload) ||
    (common.pageList.isFetching || !common.pageList.payload) ||
    (common.productAttributeList.isFetching || !common.productAttributeList.payload)
}
